import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

export const runRebateForecastStep = defineStepConfig({
  type: "run_rebate_forecast",
  name: "Run Rebate Forecast",
  description: "Generates and persists rebate forecasts for active agreements",
  category: "Utility",
  libraryModule: "Rebates",

  // No typed inputs - this step is triggered via flow control from a trigger node.
  // Uses current date/time when executed.
  inputSchema: z.object({}),

  outputSchema: z.object({
    estimatesStored: z.number(),
    forecastsStored: z.number(),
    estimatesOverwritten: z.number(),
    forecastsPreserved: z.number(),
  }),

  configSchema: z.object({
    yearOffset: z
      .number()
      .int()
      .min(-5)
      .max(0)
      .prefault(0)
      .describe(
        "Year offset relative to current year (0 = current, -1 = last year)",
      ),
  }),

  execution: {
    startToCloseTimeout: "30 minutes",
  },

  emits: [] as const,
});
